module.exports = __webpack_public_path__ + "static/media/chatboss-3.4632a349.svg";